module.exports = __webpack_public_path__ + "static/media/question-mark.406bf07c.svg";